var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C6.7338 0.00242795 4.55174 0.863055 2.88881 2.41032C1.22587 3.95759 0.204205 6.07784 0.0274601 8.34842C-0.149285 10.619 0.531872 12.8731 1.93516 14.6615C3.33845 16.4498 5.3608 17.641 7.59905 17.9976V11.669H5.29471V9.05219H7.59905V7.05921C7.59905 4.78948 8.9372 3.5296 10.9952 3.5296C11.6683 3.53961 12.3395 3.60374 13.0024 3.72138V5.93527H11.8744C10.756 5.93527 10.3985 6.63925 10.3985 7.35536V9.05462H12.9033L12.5024 11.6715H10.401V18C12.6392 17.6434 14.6615 16.4522 16.0648 14.6639C17.4681 12.8756 18.1493 10.6214 17.9725 8.35085C17.7958 6.08027 16.7741 3.96001 15.1112 2.41275C13.4482 0.865481 11.2662 0.00485412 9 0.00242618V0Z",
    fill: "#1877F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.69bd0973.svg";
export { ForwardRef as ReactComponent };